export default {
    BASIC : 'basic',
    ADVANCED : 'advanced',
    EXPERT : 'expert',
    PRO : 'pro'
}
